import React, { useLayoutEffect, useState } from 'react';

import Banner from './Banner'; 
import Apps from '../../Molecules/Apps';  
import ProductInfoTabs from './ProductInfoTabs'
import EVChargingSolutions from './EVChargingSolutions';
import ProductBoxAndAudience from './ProductBoxAndAudience';
import { IoChevronForwardOutline } from 'react-icons/io5';
import { BsArrowRightShort } from 'react-icons/bs';
import DemoForm from '../../Molecules/DemoForm/DemoForm'; 


export default function Homepage() {
  useLayoutEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  }, []);
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Banner />
      <ProductInfoTabs/>
      <ProductBoxAndAudience />
      <EVChargingSolutions />

      {showModal && (
        <div className="fixed !m-0 inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 ">
          <div className="bg-white rounded-2xl p-8 max-w-6xl w-full shadow-xl relative">
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-2 right-4 text-2xl font-bold text-gray-700"
            >
              &times;
            </button>
            <h2 className="text-xl font-bold mb-4">Schedule Demo</h2>
            <div className='h-[95%]'>
              <DemoForm />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
